export const SET_FORMS = 'SET_FORMS'
export const SET_FORM = 'SET_FORM'
export const SET_STEPS = 'SET_STEPS'
export const ADD_STEP = 'ADD_STEP'
export const UPDATE_STEP = 'UPDATE_STEP'
export const REMOVE_STEP = 'REMOVE_STEP'
export const SET_FIELDS = 'SET_FIELDS'
export const ADD_FIELD = 'ADD_FIELD'
export const UPDATE_FIELD = 'UPDATE_FIELD'
export const REMOVE_FIELD = 'REMOVE_FIELD'
export const SET_FIELD_TYPES = 'SET_FIELD_TYPES'
export const SET_FIELD_TYPES_GROUPED = 'SET_FIELD_TYPES_GROUPED'
export const SET_SELECTED_FIELD = 'SET_SELECTED_FIELD'
export const SET_SELECTED_STEP = 'SET_SELECTED_STEP'
export const SET_DIRTY = 'SET_DIRTY'
export const SET_LOADING = 'SET_LOADING'
export const RESET_BUILDER = 'RESET_BUILDER'
